import api from './auth'

export interface DashboardMetrics {
  emails_today: number
  emails_week: number
  emails_by_category: { category: string; count: number }[]
  open_cases: number
  appointments_today: number
  total_imaging_analyses: number
  avg_imaging_accuracy: number
}

export interface QueueStats {
  unassigned: number
  pending: number
}

export interface EmailVolume {
  date: string
  count: number
}

export interface LlmLatency {
  model: string
  avg_accuracy: number
  total_analyses: number
}

export interface AutoReplyRate {
  total_drafts: number
  approved: number
  approval_rate: number
}

export const metricsApi = {
  async getDashboard(): Promise<DashboardMetrics> {
    const response = await api.get<DashboardMetrics>('/metrics/dashboard')
    return response.data
  },

  async getQueueStats(): Promise<QueueStats> {
    const response = await api.get<QueueStats>('/metrics/queue-stats')
    return response.data
  },

  async getEmailVolume(days = 30): Promise<EmailVolume[]> {
    const response = await api.get<EmailVolume[]>('/metrics/email-volume', {
      params: { days },
    })
    return response.data
  },

  async getLlmLatency(): Promise<LlmLatency[]> {
    const response = await api.get<LlmLatency[]>('/metrics/llm-latency')
    return response.data
  },

  async getAutoReplyRate(): Promise<AutoReplyRate> {
    const response = await api.get<AutoReplyRate>('/metrics/auto-reply-rate')
    return response.data
  },
}
